
import { Layout, Modal, Table, Tabs, } from 'antd';
import "./ShopDetails.css"
import ShopDetailsTab from '../components/ShopDetailTab/ShopDetailTab';
import SelectData from '../components/SelectData/SelectData';
import { getExpensesDetails, getOrderInfo, getRefund, getRefundDetail } from '../api/store';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useEffect, useMemo, useState } from 'react';
import dayjs from 'dayjs';
import SelectEmployee from '../components/SelectEmployee/SelectEmployee';
import { useAtom } from 'jotai';
import { currentEmpoyId, currentDateNew } from '../store/employId';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import Operation from 'antd/es/transfer/operation';

dayjs.extend(utc);
dayjs.extend(timezone);


const { Header } = Layout;
const headerStyle = {
  textAlign: 'center',
  color: '#fff',
  height: 64,
  paddingInline: 48,
  lineHeight: '64px',
  backgroundColor: '#ED4948',
};


const tabItemsA = [
  {
    key: '1',
    label: '营收明细',
    children: '',
  },
  {
    key: '2',
    label: '支付明细',
    children: '',
  },
  {
    key: '3',
    label: '退货明细',
    children: '',
  },
];


const tabItemsB = [
  {
    key: '1',
    label: '营收明细',
    children: '',
  },
  {
    key: '2',
    label: '支付明细',
    children: '',
  },
];

const ShopDetails = () => {

  const navigate = useNavigate();
  const defaultTimezone = dayjs.tz.guess();

  const [searchParams] = useSearchParams()
  const [currentEmployee, setCurrentEmployee] = useAtom(currentEmpoyId)
  const [currentDateNewV, setCurrentDateNewV] = useAtom(currentDateNew)
  const [type, setType] = useState('day');
  const [info, setInfo] = useState({
    orderNum: "",
    turnover: ""
  });
  // 营收明细数据
  const [data, setData] = useState([]);
  // 支付明细数据
  const [expensesData, setExpensesData] = useState([]);
  // 退货明细
  const [refundData, setRefundData] = useState([]);

  // 明细tab键 1：营收明细 2：支付明细 3：退货明细
  const [currentTabKey, setCurrentTabKey] = useState('1');

  // const [detailsTab, setDetailsTab] = useState(tabItemsA);

  // 开始日期和结束日期是否同时为今天
  const [isToday, setIsToday] = useState(true);

  // 退款详情弹出框
  const [detailsModel, setDetailsModel] = useState({
    ticket_no: '',
    operador_name: '',
    forma_de_pago: '',
    documento_no: "",
    total: '',
    // 时间
    fecha_entrada: ''

  });
  const columns = [
    {
      title: '单号',
      dataIndex: 'order_number',
      key: 'order_number',
    },
    {
      title: '时间',
      dataIndex: 'time',
      key: 'time',
    },
    {
      title: '金额',
      dataIndex: 'total',
      key: 'total',
    },
    {
      title: '职员',
      dataIndex: 'operador_name',
      key: 'operador_name',
    },
  ];

  const [dataSource, setDataSource] = useState([])

  const detailsTab = useMemo(() =>
    (type === 'day') ? tabItemsA : tabItemsB,
    [type, isToday]
  );

  useEffect(() => {
    if (currentTabKey === '3' && detailsTab.length < 3) {
      setCurrentTabKey('2');
    }
  }, [currentTabKey, detailsTab]);

  let currentDate = [dayjs().tz(defaultTimezone).format("YYYY-MM-DD"), dayjs().tz(defaultTimezone).format("YYYY-MM-DD")];
  const ip = searchParams.get('ip')
  async function getInfo(startDate = "2025-01-01", endData = "2025-07-06", operador_id) {
    let response = null;
    console.log("关键指标+营收明细接口调用")
    if (operador_id && type === 'day') {
      response = await getOrderInfo(ip, startDate, endData, operador_id)
    } else {
      response = await getOrderInfo(ip, startDate, endData)
    }
    console.log('关键指标+营收明细接口返回的数据：', response.data)
    setInfo({
      orderNum: response.data.order_num,
      turnover: response.data.turnover,
    })
    const dataR = Object.entries(response.data.payment_amount)
    setData(dataR.map((item) => ({
      name: item[0],
      value: item[1],
    })))
  }

  // 获取支付明细数据
  async function getExpensesInfo(startDate, endDate, operador_id) {
    let response = null;
    console.log("支付明细-接口调用")
    if (operador_id && type === 'day') {
      response = await getExpensesDetails(ip, startDate, endDate, operador_id)
    } else {
      response = await getExpensesDetails(ip, startDate, endDate)
    }
    console.log('getExpensesDetails - 接口返回的数据：', response.data)

    const dataR = Object.entries(response.data)
    setExpensesData(dataR.map((item) => ({
      name: item[0],
      value: item[1],
    })))
  }

  // 获取退货明细
  async function getRefundDetails(startDate, endDate, operador_id) {
    // tab不包含退货明细时，返回
    if (detailsTab.length < 3) {
      return;
    }

    let response = null;
    console.log("退货接口明细调用：", startDate, endDate, operador_id)
    if (operador_id && type === 'day') {
      response = await getRefund(ip, startDate, endDate, operador_id)
    } else {
      response = await getRefund(ip, startDate, endDate)
    }
    console.log('getRefund - 接口返回的数据：', response.data)
    if (!response.data ) {
      setRefundData([])
      return
    }

    
    if (typeof response.data === 'object' && response.data && !Array.isArray(response.data)) {
      const dataR = Object.entries(response.data)

      setRefundData(dataR.map((item) => ({
        formaDePago: item[0],

        total: item[1],
        count: -1,
      })))
      return;
    }
    setRefundData(response.data.map((item) => ({
      formaDePago: item.FormaDePago,
      total: item.Total,
      count: item.count,
    })))


  }


  // 根据当前tab的选中情况更新明细数据, isUpdateInfo是否需要更新营收明细
  // isUpdateInfo = true, newKey, newCurrentEmployeeId, newType
  async function updateDetailsData({
    isUpdateInfo = true,
    newKey,
    newCurrentEmployeeId,
    newType,
    newStartDate,
    newEndDate,
  }) {
    const tabKey = newKey || currentTabKey;
    let employeeId = newCurrentEmployeeId || currentEmployee;
    const startDate = newStartDate || currentDateNewV[0];
    const endDate = newEndDate || currentDateNewV[1];
    if (newType && newType !== 'day') {
      employeeId = undefined;
    }
    console.log('tabKey -- :', tabKey)
    if (tabKey === '1' && isUpdateInfo) {
      console.log('updateDetailsData-tab为营收明细')
      getInfo(startDate, endDate, employeeId)
    } else if (tabKey === '2') {
      console.log('updateDetailsData-tab为支付明细')
      getExpensesInfo(startDate, endDate, employeeId)
    } else if (tabKey === '3') {
      console.log('updateDetailsData-tab为退货明细')
      getRefundDetails(startDate, endDate, employeeId)
    }
  }

  function dateChange(date) {
    currentDate = [dayjs(date[0]).format("YYYY-MM-DD"), dayjs(date[1]).format("YYYY-MM-DD")]
    setCurrentDateNewV([
      ...currentDate
    ])
    getInfo(dayjs(date[0]).format("YYYY-MM-DD"), dayjs(date[1]).format("YYYY-MM-DD"), currentEmployee)
    updateDetailsData({
      isUpdateInfo: false,
      newKey: undefined,
      newCurrentEmployeeId: currentEmployee,
      newType: undefined,
      newStartDate: dayjs(date[0]).format("YYYY-MM-DD"),
      newEndDate: dayjs(date[1]).format("YYYY-MM-DD"),
    })


  }



  // 日 周 月 季 年 修改顶部tab
  function tabChange(type) {
    setType(type)
    if (type !== 'day') {
      if (currentTabKey === '3' ) {
        console.log('顶部tab变化，导致tab数量减少, 设置当前key为支付明细' ,detailsTab.length)
        setCurrentTabKey('2')
        updateDetailsData({
          isUpdateInfo: false,
          newKey: '2',
          newCurrentEmployeeId: undefined,
          newType: type,
          newStartDate: undefined,
          newEndDate: undefined,
        })
      }
    }
  }

  // 员工切换
  function employeeChange(employee) {
    setCurrentEmployee(employee)
    getInfo(currentDateNewV[0], currentDateNewV[1], employee)

    updateDetailsData({
      isUpdateInfo: true,
      newKey: undefined,
      newCurrentEmployeeId: employee,
      newType: undefined,
      newStartDate: undefined,
      newEndDate: undefined,
    })
  }

  function goBack() {
    navigate(-1)
  }

  // 明细tab切换
  const onDetailTabChange = (key) => {
    console.log("明细tab变化");
    setCurrentTabKey(key);
    updateDetailsData({
      isUpdateInfo: true,
      newKey: key,
      newCurrentEmployeeId: undefined,
      newType: undefined,
      newStartDate: undefined,
      newEndDate: undefined,
    })
  };



  function isTodayChange(newIsToday) {
    setIsToday(newIsToday);

    if (!isToday) {
      if (currentTabKey === '3' && detailsTab.length === 2) {
        console.log('tab数量减少, 设置当前key为支付明细', detailsTab.length)
        setCurrentTabKey('2')
        updateDetailsData({
          isUpdateInfo: false,
          newKey: '2',
          newCurrentEmployeeId: undefined,
          newType: undefined,
          newStartDate: undefined,
          newEndDate: undefined,
        })
      }
    }


  }

  const [isModalOpen, setIsModalOpen] = useState(false);


  const showModal = async (item) => {
    console.log('点击的item: ', item)
    const response = await getRefundDetail(ip, currentDateNewV[0], currentDateNewV[1], item.formaDePago, currentEmployee)
    console.log('getRefundDetail - 获取的接口数据：', response.data)

    if (!response.data || response.data.length < 0) {
      return;
    }
    setDataSource(response.data.map(item => {
      return {
        order_number: item.ticket_no ? item.ticket_no : item.documento_no,
        time: item.fecha_entrada,
        total: item.total,
        operador_name: item.operador_name
      }
    }))
    setIsModalOpen(true);
  };

  const handleOk = () => {
    setIsModalOpen(false);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  return (
    <div className='shop-details'>
      <Header style={headerStyle}>
        <div className='header-container'>
          <div className='header-button'></div>
          <div>店铺信息</div>
          <div className='header-button' onClick={goBack}>返回</div>
        </div>
      </Header>
      <ShopDetailsTab onTabChange={(tabId) => tabChange(tabId)} />
      <SelectData type={type} onDateChange={(date) => dateChange(date)} isTodayChange={(isToday) => isTodayChange(isToday)} />
      {
        type === "day" ? (<SelectEmployee onEmployeeChange={(employee) => employeeChange(employee)} ip={ip} />) : ""
      }
      {/* <Input placeholder="输入客户名称/电话/CIF，下拉匹配" /> */}
      {/* 信息 */}
      <div className="pack-up-bar">
      </div>
      <div className="shop-details-container">
        <div className='title-one'>总收入</div>
        <div className='title-two'>{info.turnover}</div>
      </div>
      <div className="sub-shop-details-container">
        <div className='sub-title space-between-item'>
          <p>总单数</p>
          <p>{info.orderNum}</p>
        </div>

        <div className="gap-line"></div>
        <div className='tab-wrapper'>
          <Tabs defaultActiveKey="1" type="line" items={detailsTab} onChange={onDetailTabChange} />
        </div>
        {
          currentTabKey === '1' ? (
            data.map((item) => (<div className='sub-item space-between-item' key={item.name}>
              <p>{item.name}</p>
              <p>{item.value}</p>
            </div>))
          ) : currentTabKey === '2' ? (
            expensesData.map((item) => (<div className='sub-item space-between-item' key={item.name}>
              <p>{item.name}</p>
              <p>{item.value}</p>
            </div>))
          ) : (
            refundData.map((item) => (<div onClick={() => showModal(item)} className='sub-item space-between-item' key={item.formaDePago}>
              
              <p>{item.formaDePago + (item.count < 0 ? '' : ` (${item.count}个)`)}</p>
              <p>{item.total}</p>
            </div>))
          )

        }
      </div>

      <Modal
        title="退款详情"
        closable={{ 'aria-label': 'Custom Close Button' }}
        open={isModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}
        cancelText="取消"
        centered={true}
        okText="确定"
      >
        <Table dataSource={dataSource} columns={columns}
          pagination={false} />
      </Modal>
    </div>
  );
};

export default ShopDetails;
